export const pricePlaceholderVariable = '{price}';
export const currencyPlaceholderVariable = '{currency}';
